<template>
  <li class="item">
    <menu-link :href="item.url">{{sanitize(item.title)}}</menu-link>
    <ul v-if="item.child_items" class="sub-menu">
      <menu-item v-for="childItem in item.child_items" :key="childItem.ID" :item="childItem" />
    </ul>
  </li>
</template>
<script>
import menuLink from '@/components/common/menuLink';

export default {

	name: 'menu-item',

	components: {
		menuLink,
	},

	props: {
		item: {
			type: Object,
			required: true,
		},
	},

	methods: {
		/**
     * Remove ugly HTML from menu item titles.
     * Don't ask why we need to do this, just try without ¯\_(ツ)_/¯.
     * @param {String} - The HTML string to be sanitized.
     */
		sanitize(str) {
			return str.replace(/<[a-z][\s\S]*>/i, '');
		},
	},
};
</script>

<style lang="scss" scoped>

  $menu_breakpoint: 60rem;

.item {
  width: 100%;

  @media screen and (min-width: $menu-breakpoint) {
    position: relative;
    max-width: 5rem;
    margin-right: 2.5rem;

    a{
      padding: 1.5rem 0;
    }
  }
}

.item:hover {
  .sub-menu {
    display: block;
  }
}

.sub-menu {
  margin: 0 2rem 1rem;
  .item {
    padding: 0.25rem 0;
  }
  @media screen and (min-width: $menu-breakpoint) {
    display: none;
    position: absolute;
    margin: 0;
    left: 0;

    .item {
      padding: 0;
      width: 10rem;
    }

    .item a {
      padding: 1rem;
      width: 15rem;
    }
  }
}
</style>
